module.exports = __webpack_public_path__ + "img/1-ikava.70994b81.jpg";